import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { restaurant } from "../mock";
import { useLang } from "../i18n/LanguageContext";

export default function Navbar() {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const links = [
    { label: t("nav.home"), href: "#home" },
    { label: t("nav.about"), href: "#chisiamo" },
    { label: t("nav.services"), href: "#servizi" },
    { label: t("nav.menu"), href: "#menu" },
    { label: t("nav.catering"), href: "#catering" },
    { label: t("nav.reservation"), href: "#prenota" },
    { label: t("nav.gallery"), href: "#galleria" },
    { label: t("nav.contact"), href: "#contatti" },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const LangSwitch = ({ dark }) => (
    <div className={`flex items-center gap-1 text-sm font-medium ${dark ? "text-[#3a352d]" : "text-white/90"}`}>
      <button
        onClick={() => setLang("it")}
        className={`px-1.5 transition-colors ${lang === "it" ? "text-[#C9A24B]" : "opacity-60 hover:opacity-100"}`}
      >IT</button>
      <span className="opacity-40">/</span>
      <button
        onClick={() => setLang("en")}
        className={`px-1.5 transition-colors ${lang === "en" ? "text-[#C9A24B]" : "opacity-60 hover:opacity-100"}`}
      >EN</button>
    </div>
  );

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FBF7F0]/95 backdrop-blur-md shadow-[0_2px_30px_rgba(0,0,0,0.06)] py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between">
        <a href="#home" className="flex flex-col leading-none">
          <span className={`font-display text-xl md:text-2xl tracking-wide transition-colors ${scrolled ? "text-[#23201C]" : "text-white"}`}>
            L'angolo <span className="text-[#C9A24B] italic">del Gusto</span>
          </span>
          <span className={`text-[10px] tracking-[0.35em] uppercase mt-1 transition-colors ${scrolled ? "text-[#8a7f6b]" : "text-white/70"}`}>
            Oristano · Sardegna
          </span>
        </a>

        <nav className="hidden xl:flex items-center gap-7">
          {links.map((l) => (
            <a key={l.href} href={l.href}
              className={`nav-link text-sm font-medium tracking-wide transition-colors ${scrolled ? "text-[#3a352d] hover:text-[#23201C]" : "text-white/90 hover:text-white"}`}>
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-5">
          <LangSwitch dark={scrolled} />
          <a href="#prenota"
            className="group flex items-center gap-2 border border-[#C9A24B] text-[#C9A24B] hover:bg-[#C9A24B] hover:text-[#1C1815] px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300">
            <Phone size={15} />
            {t("nav.book")}
          </a>
        </div>

        <div className="flex items-center gap-4 xl:hidden">
          <LangSwitch dark={scrolled} />
          <button className={scrolled ? "text-[#23201C]" : "text-white"} onClick={() => setOpen(true)} aria-label="Menu">
            <Menu size={28} />
          </button>
        </div>
      </div>

      <div className={`fixed inset-0 z-50 xl:hidden transition-all duration-500 ${open ? "visible" : "invisible"}`}>
        <div className={`absolute inset-0 bg-black/50 transition-opacity ${open ? "opacity-100" : "opacity-0"}`} onClick={() => setOpen(false)} />
        <div className={`absolute right-0 top-0 h-full w-[82%] max-w-sm bg-[#1C1815] text-white px-8 py-8 transition-transform duration-500 ${open ? "translate-x-0" : "translate-x-full"}`}>
          <div className="flex justify-between items-center mb-12">
            <span className="font-display text-xl">{t("nav.menu")}</span>
            <button onClick={() => setOpen(false)} aria-label="Close"><X size={26} className="text-[#C9A24B]" /></button>
          </div>
          <nav className="flex flex-col gap-5">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                className="font-serif-alt text-2xl text-white/90 hover:text-[#C9A24B] transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
          <a href="#prenota" onClick={() => setOpen(false)}
            className="mt-10 flex items-center justify-center gap-2 bg-[#C9A24B] text-[#1C1815] px-5 py-3 rounded-full font-medium">
            <Phone size={16} /> {t("nav.book")}
          </a>
        </div>
      </div>
    </header>
  );
}